import moment from 'moment'

export function closestToIndex(x, arr = []) {
  let getter = moment(x).isValid()
    ? item => moment(item).toDate().getTime()
    : item => item === undefined ? Infinity : item
  const distances = arr.map(item => Math.abs(getter(x) - getter(item)))
  const index = distances.indexOf(Math.min(...distances))
  return index === -1 ? null : index
}

// Detects coords of intersecion of 2 lines
export function lineIntersection(a1, a2, b1, b2) {
  const uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x)
  const ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x)
  const uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y)
  if (uB !== 0) {
    const ua = uaT / uB
    const ub = ubT / uB
    if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
      return {
        x: a1.x + ua * (a2.x - a1.x),
        y: a1.y + ua * (a2.y - a1.y)
      }
    } else {
      // no intersection
      return null
    }
  } else {
    if (uaT === 0 || ubT === 0) {
      // coincident
      return null
    } else {
      // parallel
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/utils.js